export default __webpack_public_path__ + "static/media/loading.1a8a581d.png";